export interface AgentRole {
  category: string;
  icon: string | null;
  description?: string;
}

export const agentRoles: AgentRole[] = [
  {
    category: 'No Filter',
    icon: null
  },
  {
    category: 'Controller',
    icon: '../assets/images/controller-icon.webp',
    description: "Controllers are experts in slicing up dangerous territory to set their team up for success.",
  },
  {
    category: 'Duelist',
    icon: '../assets/images/duelist-icon.webp',
    description: "Duelists are self-sufficient fraggers who their team expects, through abilities and skills, to get high frags and seek out engagements first.",
  },
  {
    category: 'Initiator',
    icon: '../assets/images/initiator-icon.webp',
    description: "Initiators challenge angles by setting up their team to enter contested ground and push defenders away.",
  },
  {
    category: 'Sentinel',
    icon: '../assets/images/sentinel-icon.webp',
    description: "Sentinels are defensive experts who can lock down areas and watch flanks, both on attacker and defender rounds.",
  },
];
